/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React from 'react'
import { graphql, useStaticQuery, Link } from 'gatsby'
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { jsx } from 'theme-ui'
import { MenuPopper } from './menuPopper'
import NavDrawer from './navDrawer'
import TopNav from './topnav'
import { Box, Flex } from '../elements'
import Logo from '../Logo'
import ReviewsWidget from '../ReviewsWidget'
import { withVSensor } from '../VSensor'

// eslint-disable-next-line import/exports-last
export const NavWrapper = ({ ...props }) => (
  <Box
    {...props}
    sx={{
      position: 'relative',
      top: 0,
      left: 0,
      m: 0,
      zIndex: 5,
      width: '100%',
      transition: '0.35s ease-in-out',
      a: { textDecoration: 'none' },
      fontFamily: "'Barlow Condensed', Barlow, sans-serif",
      textTransform: 'uppercase',
    }}
  />
)

const ChildMenu = ({ item }) => {
  return <MenuPopper item={item} />
}

export const NavBar = withVSensor(() => {
  const breakpoints = useBreakpoint()
  const {
    allWpMenuItem: { nodes },
  } = useStaticQuery(graphql`
    fragment MenuFields on WpMenuItem {
      id
      label
      url

      menuIcon {
        fieldGroupName
        icon
      }
    }
    query GET_MENU_ITEMS {
      site {
        siteMetadata {
          wpUrl
        }
      }
      file(relativePath: { eq: "Review.png" }) {
        childImageSharp {
          fixed(width: 165) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      allWpMenuItem(filter: { locations: { eq: MAIN_MENU }, parentDatabaseId: { eq: 0 } }) {
        nodes {
          menuImage {
            fieldGroupName
            image {
              sourceUrl
              localFile {
                childImageSharp {
                  gatsbyImageData(transformOptions: { cropFocus: ATTENTION })
                }
              }
            }
          }
          ...MenuFields
          childItems {
            nodes {
              menuImage {
                fieldGroupName
                image {
                  sourceUrl
                  localFile {
                    childImageSharp {
                      gatsbyImageData(transformOptions: { cropFocus: ATTENTION })
                    }
                  }
                }
              }
              ...MenuFields
              childItems {
                nodes {
                  ...MenuFields
                  childItems {
                    nodes {
                      ...MenuFields
                      childItems {
                        nodes {
                          ...MenuFields
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)
  return (
    <NavWrapper pt={0} position="relative" bg="white">
      <TopNav />
      <NavDrawer
        items={nodes}
        sx={{
          position: 'absolute',
          left: 3,
          bottom: '20%',
          zIndex: 10,
          display: ['block', 'block', 'none'],
        }}
      />

      <Flex
        pb={[15, 15, 10]}
        pt={[40, 40, 13]}
        sx={{
          alignItems: 'center',
          maxWidth: '1400px',
          position: 'relative',
          mx: 'auto',
          justifyContent: ['center', 'center', 'space-between'],
        }}
      >
        <Flex sx={{ mt: -50 }}>
          <Link to="/">
            <Logo />
          </Link>
        </Flex>
        <Flex
          sx={{
            alignItems: 'center',
            justifyContent: 'space-evenly',
            display: ['none', 'none', 'flex'],
            height: '100%',
            width: '100%',
            maxWidth: 600,
            fontWeight: 800,
          }}
        >
          {nodes.map((item, i) => (
            // eslint-disable-next-line react/no-array-index-key
            <ChildMenu item={item} key={i} />
          ))}
        </Flex>
        <Box
          mb={-80}
          sx={{
            display: ['none', 'none', 'block'],
            minWidth: 80,
          }}
        >
          {breakpoints.md ? null : (
            <Link to="/testimonials">
              <ReviewsWidget />
            </Link>
          )}
        </Box>
      </Flex>
    </NavWrapper>
  )
})

export default NavBar
